import styled from 'styled-components';

import { InfoBlockContent } from './InfoBlockContent';

export const FlexBlockContent = styled(InfoBlockContent)`
  display: flex;
  gap: 10px;
  align-items: center;

  .pencil {
    cursor: pointer;

    :hover {
      color: #858dbd;
    }
  }
`;
